export default class EstatedDeed {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.document_type = obj.document_type;
    this.recording_date = obj.recording_date;
    this.original_contract_date = obj.original_contract_date;
    this.deed_book = obj.deed_book;
    this.deed_page = obj.deed_page;
    this.document_id = obj.document_id;
    this.sale_price = obj.sale_price;
    this.sale_price_description = obj.sale_price_description;
    this.transfer_tax = obj.transfer_tax;
    this.distressed_sale = obj.distressed_sale;
    this.real_estate_owned = obj.real_estate_owned;
    this.seller_first_name = obj.seller_first_name;
    this.seller_last_name = obj.seller_last_name;
    this.seller2_first_name = obj.seller2_first_name;
    this.seller2_last_name = obj.seller2_last_name;
    this.seller_address = obj.seller_address;
    this.seller_unit_number = obj.seller_unit_number;
    this.seller_city = obj.seller_city;
    this.seller_state = obj.seller_state;
    this.seller_zip_code = obj.seller_zip_code;
    this.seller_zip_plus_four_code = obj.seller_zip_plus_four_code;
    this.buyer_first_name = obj.buyer_first_name;
    this.buyer_last_name = obj.buyer_last_name;
    this.buyer2_first_name = obj.buyer2_first_name;
    this.buyer2_last_name = obj.buyer2_last_name;
    this.buyer_address = obj.buyer_address;
    this.buyer_unit_type = obj.buyer_unit_type;
    this.buyer_unit_number = obj.buyer_unit_number;
    this.buyer_city = obj.buyer_city;
    this.buyer_state = obj.buyer_state;
    this.buyer_zip_code = obj.buyer_zip_code;
    this.buyer_zip_plus_four_code = obj.buyer_zip_plus_four_code;
    this.lender_name = obj.lender_name;
    this.lender_type = obj.lender_type;
    this.loan_amount = obj.loan_amount;
    this.loan_type = obj.loan_type;
    this.loan_due_date = obj.loan_due_date;
    this.loan_finance_type = obj.loan_finance_type;
    this.loan_interest_rate = obj.loan_interest_rate;
  }

  get primaryBuyerName() {
    return `${this.buyer_first_name} ${this.buyer_last_name}`;
  }
}
